export default "__VITE_ASSET__CGkChSpF__"